export default {
  body: {
    flight: {
      routeList: {
        route: { originAirportCode: "GRU", destinationAirportCode: "CNF", departureDate: "2023-06-04T09:40:00" },
      },
      chosenFlightSegmentList: {
        chosenFlightSegment: {
          type: "SEGMENT_1",
          chosenFlight: {
            stops: "0",
            cabin: "ECONOMIC",
            airline: { code: "G3", name: "GOL" },
            departure: {
              date: "2023-06-04T09:40:00",
              airport: { code: "GRU", name: "Guarulhos", city: "São Paulo", mac: "SAO", timeZone: "America/Sao_Paulo" },
            },
            arrival: { date: "2023-06-04T10:50:00", airport: { code: "CNF", name: "Confins", city: "Belo Horizonte" } },
            duration: { hours: "1", minutes: "10" },
            legList: {
              leg: {
                cabin: "ECONOMIC",
                departure: {
                  date: "2023-06-04T09:40:00",
                  airport: { code: "GRU", name: "Guarulhos", city: "São Paulo" },
                },
                arrival: {
                  date: "2023-06-04T10:50:00",
                  airport: { code: "CNF", name: "Confins", city: "Belo Horizonte" },
                },
                flightNumber: "1320",
                marketingAirline: { code: "G3", name: "GOL" },
                operationAirline: { code: "G3", name: "GOL" },
                equipment: "738",
                isConnection: "false",
              },
            },
          },
          recordLocator: "MMIGBE",
          passengerList: {
            passenger: {
              index: "0",
              type: "ADT",
              firstName: "GIOVANA",
              lastName: "EVANGELSITA",
              gender: "FEMALE",
              birthday: "1997-02-03",
              email: "GIOVANAEVANGELISTA1404@GMAIL.COM",
              requestSpecialServiceList: { requestSpecialService: ["FQTR", "TKNE", "BRND"] },
              ticketNumber: "1272189433472",
            },
          },
        },
      },
      passengerList: {
        passenger: {
          index: "0",
          type: "ADT",
          firstName: "GIOVANA",
          lastName: "EVANGELSITA",
          gender: "FEMALE",
          birthday: "1997-02-03",
          email: "GIOVANAEVANGELISTA1404@GMAIL.COM",
          requestSpecialServiceList: { requestSpecialService: ["FQTR TKNE BRND", "FQTR TKNE BRND", "FQTR TKNE BRND"] },
          ticketNumber: "1272189433472",
        },
      },
      source: "G3",
      allowedCancelPassenger: "true",
      allowedCancelSegments: "false",
      allowedCancelFull: "false",
      isInvoluntaryCancel: "false",
    },
  },
};

// "allowedCancelPassenger": "false",
//       "allowedCancelSegments": "false",
//       "allowedCancelFull": "false",
